const state = {
  state:sessionStorage.getItem('state') ? JSON.parse(sessionStorage.getItem('state')): {
    firsrd: 666,
    end_time: '',
    stated:'',
    applytit:false,
    odercred:{},
  }}
const getters = {

}
const mutations = {
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/cheng/store.js